import { makeAutoObservable, observable, action } from "mobx";
import { client } from "../store";
import api from "store/api";
import qs from "qs";
import { errorHandler } from "utils/middlewares/errorHandler";
import { makePersistable } from "mobx-persist-store";

class PaymentInfoStore {
  locationBillingAccounts = null;
  stripeCreditCards = [];
  defaultPaymentMethodId = null;
  defaultSelectedCard = null;
  newCard = null;
  cardElement = null;

  newCard = false;
  cardElement = null;

  constructor() {
    makePersistable(this, {
      name: "PaymentInfoStore",
      properties: [
        "locationBillingAccounts",
        "stripeCreditCards",
        "defaultSelectedCard",
        "defaultPaymentMethodId",
      ],
      storage: window.localStorage,
    });
    makeAutoObservable(this, {
      locationBillingAccounts: observable,
      stripeCreditCards: observable,

      getLocationBillingAccounts: action,
      updateBillingAccount: action,
      getLocationCreditCards: action,
      setDefaultPaymentMethod: action,
      updateDefaultLocationCreditCards: action,
      createLocationCreditCard: action,
      removeLocationCreditCard: action,
      requestInvoiceAvailability: action,
      createLocationPaymentIntent: action,
    });
  }

  async getLocationBillingAccounts(params) {
    let paramsString = qs.stringify(params);

    return client()
      .get(`${api.billingAccounts()}/${params.location_id}?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          this.locationBillingAccounts = data?.data;

          return data?.data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  async updateBillingAccount(locationId, payload) {
    return client()
      .put(
        `${api.billingAccounts()}/${locationId}?location_id=${locationId}`,
        payload
      )
      .then(
        action("fetchSuccess", ({ data }) => {
          this.locationBillingAccounts = data?.data;

          return data?.data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  resetCreditCards() {
    this.stripeCreditCards = null;
    this.defaultPaymentMethod = null;
    this.defaultPaymentMethodId = null;
    this.defaultSelectedCard = null;
  }

  async getLocationCreditCards(params) {
    let paramsString = qs.stringify(params);

    this.resetCreditCards();
    return client()
      .get(`${api.cards()}/?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          this.stripeCreditCards = data;
          this.setDefaultPaymentMethod(data?.customer);
          if (data?.customer && data?.payment_methods) {
            this.setDefaulSelectedCard(data?.customer, data?.payment_methods);
          }

          return data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  setDefaultPaymentMethod(customer) {
    this.defaultPaymentMethod =
      customer?.invoice_settings?.default_payment_method;
  }

  setDefaulSelectedCard(customer, paymentMethods) {
    const defaultPaymentId = customer?.invoice_settings?.default_payment_method;
    this.defaultPaymentMethodId = defaultPaymentId;
    let card = paymentMethods?.data?.find(
      (card) => card?.id == defaultPaymentId
    );

    this.defaultPaymentMethodId = defaultPaymentId;
    this.defaultSelectedCard = {
      expMonth: card?.card?.exp_month,
      expYear: card?.card?.exp_year,
      brand: card?.card?.display_brand,
      last4: card?.card?.last4,
      customer_id: card?.customer,
      id: card?.id,
    };
  }

  resetDefaultPaymentMethodAndCard() {
    this.defaultSelectedCard = null;
    this.defaultPaymentMethodId = null;
  }

  async updateDefaultLocationCreditCards(paymentID, params) {
    let paramsString = qs.stringify(params);

    return client()
      .put(`${api.cards()}/${paymentID}?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          this.getLocationCreditCards({ location_id: params?.location_id });

          return data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  async createLocationCreditCard(params) {
    let paramsString = qs.stringify(params);

    return client()
      .post(`${api.cards()}?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          return data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  async removeLocationCreditCard(params) {
    let paramsString = qs.stringify(params);

    return client()
      .delete(`${api.cards()}/${params.card_id}?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          return data;
        }),
        action("fetchError", (error) => {
          return error;
        })
      );
  }

  async createLocationPaymentIntent(params) {
    let paramsString = qs.stringify(params);

    return client()
      .post(`${api.paymentIntent()}?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          return data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  async requestInvoiceAvailability(locationId, payload) {
    return client()
      .put(
        `${api.locationAddress()}/${locationId}?location_id=${locationId}`,
        payload
      )
      .then(
        action("fetchSuccess", ({ data }) => {
          return data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  saveCardElements(cardElement) {
    this.newCard = true;
    this.cardElement = cardElement;
  }

  setIsNewCard(newCard) {
    this.newCard = newCard;
  }

  async createSetupIntent(params) {
    let paramsString = qs.stringify(params);

    return client()
      .post(`${api.setupIntent()}?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          return data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }

  async getTemporaryCreditCards(id, params) {
    let paramsString = qs.stringify(params);

    return client()
      .get(`${api.cards()}/${id}?${paramsString}`)
      .then(
        action("fetchSuccess", ({ data }) => {
          return data;
        }),
        action("fetchError", (error) => {
          errorHandler(error?.response);
          return error;
        })
      );
  }
}

const paymentInfoStore = new PaymentInfoStore();
export default paymentInfoStore;
